// extracted by mini-css-extract-plugin
export default {"root":"IconX_root__SAvrX"};